import axios from "axios";
import { localStorageInstance } from "../utils/localStorage";
import { currentUserToken, getAPIBaseUrlVersion1 } from "../utils/constants";
import { refreshToken } from "./apiAuth";
import { showLoader, hideLoader } from "../utils/loader";
import { subscriptionManager } from "../utils/subscriptionManager"; 

const Api = axios.create({
  baseURL: getAPIBaseUrlVersion1() || "",
});

Api.interceptors.request.use(function (response) {
  const token = currentUserToken();
  if (token !== undefined && token !== null) {
    response.headers["token"] = `${token}`;
  }
  return response;
});

Api.interceptors.response.use(
  (response) => response,
  async (error) => {
    // Debug logging
    console.log("[Axios Interceptor] Error received:", error, {
      status: error?.response?.status,
      statusText: error?.response?.statusText,
      url: error?.config?.url,
      hasResponse: !!error?.response,
    });

    // Handle subscription expired (423 status code)
    // Only process if error.response exists and status is 423
    if (error?.response?.status === 423) {
      console.log("[Axios Interceptor] 423 status code detected - notifying subscription manager");
      subscriptionManager.notifyExpired();
      console.log("[Axios Interceptor] Subscription manager notified");
      return Promise.reject(error);
    }

    if (error?.response?.status === 401) {
      showLoader();
      try {
        const refresh_token = localStorageInstance.getItem("refresh_token");

        if (!refresh_token) throw new Error("No refresh token");

        const res = await refreshToken(refresh_token);
        const newToken = res?.data?.data?.responseData[0]?.token?.access_token;

        localStorageInstance.setItem({ key: "token", value: newToken });
        localStorageInstance.setItem({ key: "refresh_token", value: res.data.data.responseData[0].token.refresh_token });

        error.config.headers["token"] = newToken;
        hideLoader();
        return Api.request(error.config);
      } catch (refreshError) {
        console.log("in error interceptor ===== in catch block ", refreshError);
        hideLoader();
        localStorageInstance.clear();
        const attemptedUrl = `${window.location.pathname}${window.location.search}`;
        window.location = `${window.location.origin}?url=${attemptedUrl}`;
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

export default Api;
